// extracted by mini-css-extract-plugin
export default {"imagesStack":"_1cw0iul","badges":"_18tvus3","icon":"_1l6o598","img":"_1ku3xa8","iconBackdrop":"_8bnpci"};